import { render, staticRenderFns } from "./RightMenuSamplePreview_Ap.vue?vue&type=template&id=0dbb9d51&scoped=true"
import script from "./RightMenuSamplePreview_Ap.vue?vue&type=script&lang=js"
export * from "./RightMenuSamplePreview_Ap.vue?vue&type=script&lang=js"
import style0 from "./RightMenuSamplePreview_Ap.vue?vue&type=style&index=0&id=0dbb9d51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb9d51",
  null
  
)

export default component.exports